import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { IBriefInfluencerV2 } from "@shared/lib/types/briefInfluencerV2";
import { BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY } from "../../constants";
import { BriefService } from "../../services/brief.service";

export function useReRunBriefAiFitCheck(
  updateBriefInfluencer: (id: string, data: IBriefInfluencerV2) => void
) {
  const {
    mutate: reRunBriefAiFitCheck,
    isLoading: isReRunning,
    isSuccess: isReRunSuccess,
    variables,
  } = useMutation({
    mutationFn: (briefInfluencerId: string) =>
      BriefService.reRunBriefAiFitCheck(briefInfluencerId),
    options: {
      skipInvalidation: true,
    },
    onSuccess: (c, data, briefInfluencerId) => {
      ToastService.success("Brief AI Fit Check Re-Run Successfully");
      updateBriefInfluencer(briefInfluencerId, data.data);
      c.invalidateQueries({
        queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY],
        exact: false,
      });
    },
  });

  return {
    reRunBriefAiFitCheck,
    isReRunning,
    isReRunSuccess,
    variables,
  };
}
